"use client"

import { BookOpen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BookOpenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BookOpenIcon = component(Icon)({ as: BookOpen })
